import { Download, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
import './Hero.css';

const GITHUB_REPO = 'https://github.com/IntelligentElectron/universal-netlist';
const GITHUB_RELEASES = `${GITHUB_REPO}/releases`;

/**
 * Hero section with animated circuit icon and CTAs.
 */
export function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        {/* Animated Diode Icon */}
        <div className="hero-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Anode lead */}
            <path d="M4 32H16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />

            {/* Triangle (diode body) */}
            <path
              d="M16 20V44L40 32L16 20Z"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinejoin="round"
            />

            {/* Schottky cathode bar with S-bends */}
            <path d="M40 20V44" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            <path
              d="M40 20H44V24"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M40 44H36V40"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            {/* Cathode lead */}
            <path d="M40 32H60" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </div>

        {/* Text Content */}
        <div className="hero-text">
          <h1 className="hero-title animate-slide-down">
            AI-Powered <span className="gradient-text">Circuit Intelligence</span>
          </h1>
          <p className="hero-description animate-slide-down delay-100">
            The first MCP server for EDA netlists. Query circuits with natural language through
            Claude, VS Code, or Cursor.
          </p>
        </div>

        {/* CTAs */}
        <div className="hero-actions animate-slide-up delay-200">
          <Button variant="primary" size="lg" icon={<Download size={20} />} href={GITHUB_RELEASES}>
            Download on GitHub
          </Button>
          <Button
            variant="secondary"
            size="lg"
            icon={<ExternalLink size={18} />}
            href={`${GITHUB_REPO}#readme`}
          >
            View Documentation
          </Button>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="hero-bg-glow" aria-hidden="true" />
      <div className="hero-bg-grid" aria-hidden="true" />
    </section>
  );
}
